import { Controller } from 'stimulus';

class CountryVat extends Controller {
  connect() {
    if (!this.data.has('information')) {
      throw new Error('country-vat controller requires data-country-vat-information to be defined');
    }

    this.information = JSON.parse(this.data.get('information'));

    this.onCountryChange();
  }

  selectedCountryId() {
    return parseInt(this.countryTarget.value, 10);
  }

  onCountryChange() {
    const countryId = this.selectedCountryId();

    // Retrieve the vat information from the element. This will contain
    // information like the prefix (e.g. BE), pattern of the VAT number etc.
    const countryVatInformation = typeof this.information[countryId] !== 'undefined'
      ? this.information[countryId]
      : null;

    const showVatField = !!countryVatInformation && CountryVat.isBusiness();
    const showCocField = countryId === 1 && !!countryVatInformation && CountryVat.isBusiness();

    this.toggleVatField(showVatField);
    this.toggleCocField(showCocField);

    this.toggleVatFieldRequired(showVatField);
    this.toggleCocFieldRequired(showCocField);

    if (!countryVatInformation) {
      return;
    }

    // Toggle attributes on the input field, primarily for validation
    this.outputAttributeToVatInputField('pattern', countryVatInformation.pattern);
    this.outputAttributeToVatInputField('minlength', countryVatInformation.minLength);
    this.outputAttributeToVatInputField('maxlength', countryVatInformation.maxLength);
    this.outputAttributeToVatInputField('data-porta-pattern-mismatch-message', countryVatInformation.patternValidationMessage);
    this.outputAttributeToVatInputField('data-porta-minlength-message', countryVatInformation.patternValidationMessage);
    this.outputAttributeToVatInputField('data-porta-maxlength-message', countryVatInformation.patternValidationMessage);

    // Toggle prefix element and set the prefix
    this.vatFieldPrefixTarget.style.display = countryVatInformation.prefix ? 'flex' : 'none';
    this.vatFieldPrefixTarget.textContent = countryVatInformation.prefix;
  }

  toggleVatFieldRequired(state) {
    this.vatFieldInput()[state ? 'setAttribute' : 'removeAttribute']('required', 'required');
  }

  toggleCocFieldRequired(state) {
    this.cocFieldInput()[state ? 'setAttribute' : 'removeAttribute']('required', 'required');
  }

  toggleVatField(state) {
    this.vatFieldTarget.style.display = state ? 'flex' : 'none';
  }

  toggleCocField(state) {
    this.cocFieldTarget.style.display = state ? 'flex' : 'none';
  }

  vatFieldInput() {
    return this.vatFieldTarget.querySelector('input');
  }

  cocFieldInput() {
    return this.cocFieldTarget.querySelector('input');
  }

  outputAttributeToVatInputField(key, value) {
    const attributeValue = typeof value !== 'undefined' && value ? value : null;

    const inputField = this.vatFieldInput();

    if (!inputField) {
      return;
    }

    inputField[attributeValue ? 'setAttribute' : 'removeAttribute'](key, attributeValue);
  }

  static isBusiness() {
    const orderTypeRadio = document.querySelector('[name="order_type"]:checked');

    if (!orderTypeRadio) {
      return true;
    }

    return orderTypeRadio.value === 'business';
  }
}

CountryVat.targets = [
  'country',
  'cocField',
  'vatField',
  'vatFieldPrefix',
];

export default CountryVat;
